import React, { useEffect, useState } from 'react';

import _, { conformsTo } from 'lodash';
import cx from 'classnames';

import { AnimationComponent } from '../../Animations';
import { useActionExectioner } from '../core/actions';
import { HotspotTrigger } from '../../../components/hotspot';
import { getDropShadow } from '../../../services/cssHelper.service';

import { getColorsConfig } from '../../../components/AssetViewer/helper/cssHelper';

import styles from './rectangle.module.scss';

const RectangleWidgetComponent = ({ className, style, widgetProps, breakpoint, onClick }) => {
  const actionExcutioner = useActionExectioner();

  const ref = React.useRef();

  const id = _.get(widgetProps, 'uid');
  const action = _.get(widgetProps, 'actions.0');

  const properties = _.get(widgetProps, `properties.${breakpoint}`);
  const defaultProperties = _.get(widgetProps, `properties.desktop`, {});
  const animation = _.get(widgetProps, `properties.${breakpoint}.animation`) || {};
  const layout = _.get(properties, 'layout');
  const flip =  _.get(properties, `flip`);
  const horizontalFlip = _.get(flip, 'horizontal');
  const verticalFlip = _.get(flip, 'vertical');
  const rotate = getFlipStyles(horizontalFlip, verticalFlip);

  var widgetStyle = {
    ...style,
    height: layout.height,
    width: layout.width
  }

  if (action) {
    widgetStyle = {
      ...widgetStyle,
      cursor: 'pointer'
    }
  }

  var rectangleStyle = {
    height: layout.height,
    width: layout.width,
    transform: rotate,
    ...getStyles(defaultProperties)
  };

  const handleClick = onClick ? onClick : (e) => {
    if (action) {
      e.stopPropagation();
      actionExcutioner.execute(widgetProps, action);
    }
  }

  return (
    <HotspotTrigger widget={widgetProps} breakpoint={breakpoint} targetRef={ref}>
      <div id={id}
        ref={ref}
        className={cx(className, styles.rectangle)}
        style={widgetStyle}
        data-widget-id={id}
        onClick={handleClick}
      >
        <AnimationComponent {...animation}>
          <div className={styles.inner} style={rectangleStyle} />
        </AnimationComponent>
      </div>
    </HotspotTrigger>
  );
}

const rectangleWidgetEquals = function (prevProps, nextProps) {
  const paths = ['className', 'style', 'widgetProps', 'breakpoint'];
  const next = _.pick(nextProps, paths);
  const previous = _.pick(prevProps, paths);

  const equals = _.isEqual(next, previous);
  return equals;
}

export const RectangleWidget = React.memo(RectangleWidgetComponent, rectangleWidgetEquals);


function getStyles(deviceProperties) {

  var styles = {};

  if (!deviceProperties) {
    return styles;
  }

  //fill-color
  const fillRgb = _.get(deviceProperties, 'background', null);
  var background = 'inherit';
  if (fillRgb) {
    background = getColorsConfig(fillRgb);
  }

  styles['background'] = background;

  //border
  const border = _.get(deviceProperties, 'border', {});
  const borderStyle = getBorderStyles(border);
  styles = {
    ...styles,
    ...borderStyle
  }

  //DropShadow
  const shadow = _.get(deviceProperties, 'shadow', {});
  const shadowStyle = getDropShadow(shadow);
  styles = {
    ...styles,
    ...shadowStyle
  }

  return styles;
}

//flip-shape
export function getFlipStyles(horizontal, vertical) {
  var transform = '';

  if(!vertical && !horizontal) {
    return 'rotate(0deg)';
  }

  if(vertical) {
    transform = 'rotateX(180deg)';
  }

  if(horizontal) {
    transform = `${transform} rotateY(180deg)`
  }

  return transform;
}

export function getFillStyles(value) {
  if (!value) {
    return null;
  }

  const fillRgb = value;

  var fill = 'inherit';
  if (fillRgb) {
    fill = `rgba(${fillRgb.r}, ${fillRgb.g}, ${fillRgb.b}, ${fillRgb.a})`;
  }

  var styles = {
    backgroundColor: fill
  };

  return styles;
}

export function getBorderStyles(value) {
  if (!value) {
    return null;
  }

  var styles = {};
  const topLeft = _.get(value, 'radius.topLeft', null);
  const topRight = _.get(value, 'radius.topRight', null);
  const bottomLeft = _.get(value, 'radius.bottomLeft', null);
  const bottomRight = _.get(value, 'radius.bottomRight', null);

  if (topLeft) {
    styles['borderTopLeftRadius'] = parseInt(topLeft) + 'px';
  }

  if (topRight) {
    styles['borderTopRightRadius'] = parseInt(topRight) + 'px';
  }

  if (bottomLeft) {
    styles['borderBottomLeftRadius'] = parseInt(bottomLeft) + 'px';
  }

  if (bottomRight) {
    styles['borderBottomRightRadius'] = parseInt(bottomRight) + 'px';
  }

  const colorRgb = _.get(value, 'color');

  var color = 'transparent';
  if (colorRgb) {
    color = getColorsConfig(colorRgb);
  }

  styles['borderColor'] = color;

  const borderWidthString = _.get(value, 'width', null);
  var borderWidget = parseInt(borderWidthString) + 'px';

  styles['borderWidth'] = borderWidget;

  return styles;
}
